import { useAutoUpdatingRef, usePrevious } from '@quickmd-llc/frontend-utils'

export function usePreviousValueAutoUpdatingRef<T>(value: T) {
  const previousValue = usePrevious(value)
  return useAutoUpdatingRef(previousValue)
}
